// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3fREo","buttons":"SendReceipts_buttons__EQl2-","email":"SendReceipts_email__2GzCq","bookApptTitle":"SendReceipts_bookApptTitle__3qc9M"};